import {
  themeDefault,
  themeWhite,
  themePrimary,
  themeSafe,
  themeWarning,
  themeDanger,
} from '../../material-ui-theme';

const themeSelection = {
  primary: themePrimary,
  default: themeDefault,
  white: themeWhite,
  safe: themeSafe,
  danger: themeDanger,
  warning: themeWarning,
};

export default themeSelection;
